import React from 'react'
import { TouchableOpacity, View } from 'react-native'
import { useNavigation } from '@react-navigation/native'
import { useTheme } from '@ui-kitten/components'
import { StyleService, useStyleSheet } from '@style/service'
import { Icon, Text } from '@components/base'
import { useIsDarkMode } from '@config/theme'
import { ActionCardItem, NavigationProp } from './constants'

interface ActionCardProps {
  item: ActionCardItem
}

export const ActionCard = ({ item }: ActionCardProps) => {
  const styles = useStyleSheet(themedStyle)
  const theme = useTheme()
  const isDarkMode = useIsDarkMode()
  const navigation = useNavigation<NavigationProp>()

  const { label, icon, iconColor, darkIconColor, iconBackground, onPress } = item
  const bgColor = theme[iconBackground]
  const resolvedBg = isDarkMode ? `${String(bgColor)}1A` : bgColor
  const resolvedColor = theme[isDarkMode ? darkIconColor : iconColor]

  return (
    <TouchableOpacity
      style={[styles.actionCard, isDarkMode && styles.actionCardDark]}
      onPress={() => onPress(navigation)}
      accessibilityLabel={label}
    >
      <View style={[styles.actionCardIcon, { backgroundColor: resolvedBg }]}>
        <Icon name={icon} size="18" color={resolvedColor} />
      </View>
      <Text type="regular" bold style={styles.flex1}>
        {label}
      </Text>
      <Icon name="caret-right" size="20" weight="bold" color={theme['theme.text.tertiary']} />
    </TouchableOpacity>
  )
}

const themedStyle = StyleService.create({
  actionCard: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 12,
    padding: 12,
    borderRadius: 8,
    backgroundColor: 'theme.surface.base3',
  },
  actionCardDark: {
    backgroundColor: 'theme.surface.base2',
  },
  actionCardIcon: {
    width: 36,
    height: 36,
    borderRadius: 10,
    alignItems: 'center',
    justifyContent: 'center',
  },
  flex1: {
    flex: 1,
  },
})
